import { useState } from "react";
import useLabels from "../../hooks/useLabels";
import { ROLES } from "../../constants/base";
import { Icon } from "../../components/Icon";

const EditCell = ({ row, column, table }) => {
  const [getLabel] = useLabels();
  const meta = table.options.meta;
  const columnMeta = column.columnDef.meta;
  const isWarning = ["PROTOCOL"].includes(row.original?.opType);
  const isDisabled = isWarning ? false :
    meta.getErrors()?.column && Object.keys(meta.getErrors()?.column || {}).length > 0 && meta.getErrors()?.column[row.id]; //column[row.original.id || W || row.id];

  const isEdit = columnMeta?.isEditable === true;
  const isOnlyManual = columnMeta?.isOnlyManual === true;
  const isRepetitiveValid =
    ["ANALYSIS", "TREATMENT", "PROTOCOL", "WINEMAKINGPROTOCOL"].includes(
      row.original?.opType
    ) &&
    (!row.original?.repetitive ||
      (row.original?.repetitive && row.original?.isEditable));
    const [id, setId] = useState(row.original.substance_id || row.original.value);

  const setRowData = () => { 
    meta.modalHandler(row.original.id);
  }

  const setWineMakingRowData = () => {
    meta?.setValue("id", row.original?.id);
    meta?.setValue("day", row.original?.day);
    meta?.setValue("phase", {
      label: getLabel(`protocolPhase_${row.original?.phase}`),
      value: row.original?.phase,
    });
    meta?.setValue("operation", {
      label: getLabel(`protocolOperation_${row.original?.operation}`),
      value: row.original?.operation,
    });
    
    if (Number(row?.original?.day_to) > 0) {
      meta?.setValue("day_to", row?.original?.day_to);
      meta?.setValue("interval", true);
    } else {
      meta?.setValue("day_to", "");
      meta?.setValue("interval", false);  
    }

    if (row.original?.operation === "HOMOGENIZATION_MASS") {
      meta?.setValue("protocol_type", {
        label: getLabel(`protocolOperation_${row.original?.protocol_type}`),
        value: row.original?.protocol_type || "",
      });
    }

    if (
      !["OXYGENATION", "DECANT", "RACKING", "HOMOGENIZATION_MASS"].includes(
        row.original?.operation
      )
    ) {

      meta?.setValue("functional", {
        label: getLabel(`drugLabelGroup_${row.original?.functional}`),
        value: row.original?.functional,
      });
      // if (!["SO2"].includes(row?.original?.operation)) {
      // console.log('row', row.original)
      const product = {
        ...row.original?.product,
        label: row.original?.product?.name + ((row.original?.product?.unit && row.original?.product?.unit_id != 5) ? " (" + row.original?.product?.unit + ")" : ""),
        value: row.original?.product?.id,
        // // label: row.original?.product_name,
        // label: row.original?.product_name + ((row.original?.product_unit && row.original?.product_unit_id != 5) ? " (" + row.original?.product_unit + ")" : ""),
        // value: row.original?.id,
        // id: row.original?.product,
        // name: row.original?.product_name,
        // unit: row.original?.product_unit,
        // min_range: row.original?.product_min_range,
        // max_range: row.original?.product_max_range,
        // ingredients: row.original?.product_ingredients || [],
        protocol_type: "ADD"
      };

      if (["SO2", "RINSE", "VAPORIZATION"].includes(row?.original?.operation)) {
        const name = getLabel(`protocolProduct_${product?.name}`);
        product.label = product?.id === 45 ? name :`${name} (${product?.unit && product?.unit_id != 5 ? product?.unit || "" : ""})`;  // H2O has no unit
        product.name = name;
      }

      meta?.setValue("product", product);
      
      // } else if (row?.original?.operation === "SO2") {
      //   meta?.setValue("product", getLabel("protocolProduct_SO2") + " (g/hL)");
      // }
      meta?.setValue("quantity", row?.original?.quantity);
    }

    if (['RINSE', 'CLEANING', 'VAPORIZATION'].includes(row?.original?.operation)) {
      meta?.setValue("work_time", row.original?.work_time);
    }
    
    if (row?.original?.operation === "HOMOGENIZATION_MASS") {
      meta?.setValue("quantity", row.original?.quantity);
      meta?.setValue("protocol_type", {
        label: getLabel(
          `protocolType_${row.original?.protocol_type}`
        ),
        value: row.original?.protocol_type,
      });

      if ("HOMOGENIZATION_REASSEMBLY" === row.original?.protocol_type) {
        meta?.setValue("homogenization_type", {
          label: getLabel(
            `protocolHomogenizationMass_${row.original?.homogenization_type}`
          ),
          value: row.original?.homogenization_type,
        });
        meta?.setValue("work_time", row.original?.work_time);
        meta?.setValue("pause_time", row.original?.pause_time);
        meta?.setValue("motor_speed", row.original?.motor_speed);
        meta?.setValue("iter_per_day", row.original?.iter_per_day);
      }
    }
    
    if ("OXYGENATION" === row.original?.operation) {
      meta?.setValue("protocol_type", {
        label: getLabel(`protocolOXYGENATION_${row.original?.protocol_type}`),
        value: row.original?.protocol_type,
      });
      meta?.setValue("quantity", row.original?.quantity);
      if ("CUSTOM" === row.original?.protocol_type) {
        meta?.setValue("oxygenation_dose_hours", row.original?.oxygenation_dose_hours);
        meta?.setValue("oxygenation_dose_minutes", row.original?.oxygenation_dose_minutes);
      }    
      // meta?.setValue(
      //   "oxygenationIterPerDay",
      //   row.original?.iter_per_day
      // );
    }
    meta?.setValue("goal", row.original?.goal);
    meta?.setValue("note", row.original?.note);
    
    meta.setModifyMode(row.id);
    const modalType = (meta?.type === "treatment" && columnMeta?.function_type === "CONFIRM") ? "WINEMAKING_OPERATIONS" : null;
    meta.modalHandler(row.id, modalType);
  };

  const setEditedRows = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const elName = e.currentTarget.name;

    // When entering edit mode, save the current value as "old" and "new" BEFORE any early returns
    if (elName === "edit") {
      const currentValue = row.original?.quantity || row.original?.value || "";
      // Use substance_id directly (id is from winemaking_protocol_operations table, not substance)
      const substanceId = Number(
        row.original?.substance_id ||
        row.original?.product ||
        row.original?.analysis_id
      );
      
      meta?.setValue(`column.${substanceId}.old`, currentValue);
      meta?.setValue(`column.${substanceId}.new`, currentValue);
      meta?.setValue(`column.${substanceId}.value`, currentValue);
      meta?.setValue(`column.${substanceId}.substance_id`, substanceId);
    }

    if ("winemaking" === meta.type) {
      setWineMakingRowData();
      return;
    } else if (["CAPS", "BOTTLES", "TREATMENTS", "STOCK", "MACHINERIES", "FILTERS"].includes(meta.type)) {
      setRowData();
      return;
    }

    if (isDisabled && elName === "done") return;

    // update assigned drug batches when quantity changes
    if (columnMeta.function_type === "CONFIRM" && elName === "done" && columnMeta?.onConfirm) {
      const substanceId = Number(
        row.original?.substance_id ||
        row.original?.product ||
        row.original?.analysis_id
      );
      columnMeta.onConfirm(substanceId);
    }
    meta?.setEditedRows((old) => ({
      ...old,
      [row.id]: !old[row.id],
    }));

    if (elName !== "edit") {
      const substanceId = Number(
        row.original?.substance_id ||
        row.original?.product ||
        row.original?.analysis_id
      );
      meta?.revertData(row.index, elName === "cancel", substanceId);
    }
    e.stopPropagation();
  };

  const removeRow = () => {
    meta?.removeRow(row.index);
  };

  const setCheckbox = (e, row) => {
    // Toggle TanStack state
    row.getToggleSelectedHandler()(e);

    // Aggiorna anche React Hook Form
    const newCheckboxState = !meta?.getValues(`edit.${row.original.id}`);
    meta?.setValue(`edit.${row.original.id}`, newCheckboxState);
  };

  // const setCheckbox = (e, row) => {
  //   row.getToggleSelectedHandler();
  //   const newCheckboxState = !meta?.getValues(`edit.${row.original.id}`);

  //   console.log('table.getSelectedRowModel().rows', table.getSelectedRowModel()?.rows)
  //   meta?.setValue(`edit.${row.original.id}`, newCheckboxState);   // tank_id or batch_id in case of analysis/treatment on batch
  // }

  const modalHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (row.original.opType === "WINEMAKINGPROTOCOL") setWineMakingRowData();
    else if (columnMeta?.type === "drugBatchUpdate") {
      const modalType = "BATCH_SELECTOR";
      meta.modalHandler(id, modalType);
    } else  meta?.modalHandler(row.original.id);

  }

  if (isEdit && isOnlyManual && row.original?.protocolType === 'MANUAL') {
    return (
      <div className="edit-cell-container">
        <div className="edit-cell-action">
          <button onClick={setEditedRows} name="edit">
          <Icon icon="fa-gear" />
          </button>
      </div>
    </div>
    )
  } else if (isEdit && isOnlyManual && row.original?.protocolType === 'TANKS_PROTOCOL')
      return (<input
        type="checkbox"
        checked={meta?.getValues(`edit.${row.original.id}`)}
        onChange={(e) => setCheckbox(e, row)}
      />)
  else if (isOnlyManual) return;

  return (
    (isRepetitiveValid || ['PROTOCOL', 'CAPS', 'BOTTLES', 'TREATMENTS', 'STOCK', 'MACHINERIES', 'FILTERS', 'WINEMAKINGPROTOCOL'].includes(row.original?.opType)) && (
      <div className="edit-cell-container">
        {meta?.editedRows[row.id] ? (
          <div className="edit-cell-action">
            <button onClick={setEditedRows} name="cancel">
              −
            </button>{" "}
            <button
              onClick={setEditedRows}
              name="done"
              style={isDisabled ? { cursor: "not-allowed" } : {}}
              disabled={isDisabled}
            >
              ✔
            </button>
          </div>
        ) : (
          <div className="edit-cell-action"> 
            {/* {isEdit && row.original?.opType !== 'PROTOCOL' && ( */}
            {isEdit && meta?.type !== 'newAnalysisProtocol' && meta?.type !== 'analysis' && (row.original.opType !== "TREATMENTS" || (meta?.type === "treatmentApplicationUser" && columnMeta?.type === "drugBatchUpdate" && Array.isArray(row.original?.drug_batches) && row.original?.drug_batches?.length > 0)) && (
              <button 
              onClick={(e) => 
                (['CAPS', 'BOTTLES', 'TREATMENTS', 'STOCK', 'MACHINERIES', 'FILTERS', 'WINEMAKINGPROTOCOL'].includes(row.original.opType)) ? 
              modalHandler(e) : setEditedRows(e)} 
              name="edit">
                {!["ANALYSIS"].includes(row.original?.opType) ? (
                  "✐"
                ) : <Icon icon="fa-flask-vial" />
                }
              </button>
            )}
            {columnMeta?.role === ROLES.CLIENT && !["ANALYSIS", "TREATMENT", "STOCK"].includes(row.original?.opType) && (
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  removeRow();
                }}
                name="remove"
              >
                X
              </button>
            )}
          </div>
        )}
        {!["ANALYSIS", "TREATMENT", "CAPS", "BOTTLES", "TREATMENTS", "STOCK", "PROTOCOL", "MACHINERIES", "FILTERS"].includes(row.original?.opType) && (
          <input
            type="checkbox"
            checked={meta?.getValues(`edit.${row.original.id}`) ?? row.getIsSelected()}
            onChange={(e) => setCheckbox(e, row)}

            // checked={row.getIsSelected()}
            // checked={meta?.getValues(`edit.${row.original.id}`)}
            // onChange={row.getToggleSelectedHandler()}
            // onChange={(e) => setCheckbox(e, row)}
          />
        )}
      </div>
    )
  );
};

export default EditCell;
